import type { ApprovalLink, ApprovalTheme } from "./approval-queries";

export function filterApprovalLinksByAccountAccess(
  links: ApprovalLink[],
  accessibleAccountIds: Iterable<string>,
  isAdmin: boolean,
  accountAccessReady = true
): ApprovalLink[] {
  if (isAdmin) {
    return links;
  }

  if (!accountAccessReady) {
    return [];
  }

  const accessibleIds = new Set(Array.from(accessibleAccountIds, String));

  return links.filter(
    (link) =>
      link.accountIds.length > 0 &&
      link.accountIds.every((accountId) => accessibleIds.has(String(accountId)))
  );
}

export function filterApprovalThemesByVisibleLinks(
  themes: ApprovalTheme[],
  visibleLinks: ApprovalLink[],
  isAdmin: boolean
): ApprovalTheme[] {
  if (isAdmin) {
    return themes;
  }

  const visibleLinkCountByThemeId = visibleLinks.reduce((counts, link) => {
    if (!link.themeId) {
      return counts;
    }

    counts.set(link.themeId, (counts.get(link.themeId) ?? 0) + 1);
    return counts;
  }, new Map<string, number>());

  return themes.flatMap((theme) => {
    const linkCount = visibleLinkCountByThemeId.get(theme._id) ?? 0;
    return linkCount > 0 ? [{ ...theme, linkCount }] : [];
  });
}
